import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface SiteAsset {
  id: string;
  asset_key: string;
  label: string;
  category: string;
  file_path: string | null;
}

export function useSiteAssets() {
  return useQuery({
    queryKey: ["site-assets"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("site_assets")
        .select("id, asset_key, label, category, file_path")
        .order("category")
        .order("label");
      if (error) throw error;
      return data as SiteAsset[];
    },
    staleTime: 5 * 60_000, // 5 min – these rarely change
  });
}

/** Get the public URL for a site asset, or return the static fallback */
export function getSiteAssetUrl(
  assets: SiteAsset[] | undefined,
  key: string,
  fallback: string
): string {
  const asset = assets?.find((a) => a.asset_key === key);
  if (!asset?.file_path) return fallback;
  return supabase.storage.from("site-assets").getPublicUrl(asset.file_path).data.publicUrl;
}
